import { getMergedUserData } from "../pages/const";
import { getActiveBranchId, getErpAuthState } from "../erpClient";

/** Logged-in user's active branch. Prefers active_branch_id; no default to 1. */
export function getSessionBranchId() {
  const active = getActiveBranchId();
  if (active != null) return active;

  const merged = getMergedUserData();
  const erpUser = getErpAuthState()?.user;
  const raw =
    merged?.active_branch_id ??
    merged?.branch_id ??
    merged?.branchId ??
    merged?.branch ??
    erpUser?.active_branch_id ??
    erpUser?.branch_id ??
    erpUser?.branchId;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}
